import { render, staticRenderFns } from "./ListaMaterie.vue?vue&type=template&id=754597f7&scoped=true"
import script from "./ListaMaterie.vue?vue&type=script&lang=js"
export * from "./ListaMaterie.vue?vue&type=script&lang=js"
import style0 from "./ListaMaterie.vue?vue&type=style&index=0&id=754597f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754597f7",
  null
  
)

export default component.exports